import { StyledListContainer } from 'modules/campaignAnalytics/components/Styled';
import styled from 'styled-components';
import { NavTabsList, TabsGroup } from 'ui/tabsGroup';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p320: pxToRem(320),
};

export const FullWidthTabsGroup = styled(TabsGroup)`
  width: 100%;
`;

export const FullWidthNavTabsList = styled(NavTabsList)`
  width: 100%;
  padding: ${spacing.threeQuarter} ${spacing.base};
`;

export const QuickRepliesListContainer = styled(StyledListContainer)`
  height: ${customSpacing.p320};
  padding: 0;
  margin-bottom: ${spacing.plusHalf};
  overflow-y: auto;
`;

export const RightAlignedMetric = styled.div`
  text-align: right;
  min-width: ${spacing.x3}; 
`;
